var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import ModelInfo from '@backoffice/components/claim/ModelInfo.vue';
import { droughtDependenciesFields, droughtFacadeDamagesFields, droughtInteriorDamagesFields, } from '@shared/qualification/droughtQualificationFields';
const claim = namespace('claim');
let DroughtDamages = class DroughtDamages extends Vue {
    get modelFieldsContext() {
        return this.modelFieldsContextGetter(this.$tc.bind(this), false);
    }
    get facadeDamages() {
        const context = this.modelFieldsContext;
        if (!context || !this.heliosDeclaration) {
            return [];
        }
        return droughtFacadeDamagesFields(this.heliosDeclaration, context);
    }
    get interiorDamages() {
        const context = this.modelFieldsContext;
        if (!context || !this.heliosDeclaration) {
            return [];
        }
        return droughtInteriorDamagesFields(this.heliosDeclaration, context);
    }
    get dependenciesDamages() {
        const context = this.modelFieldsContext;
        if (!context || !this.heliosDeclaration) {
            return [];
        }
        return droughtDependenciesFields(this.heliosDeclaration, context);
    }
};
__decorate([
    claim.Getter('modelFieldsContext')
], DroughtDamages.prototype, "modelFieldsContextGetter", void 0);
__decorate([
    claim.State('info')
], DroughtDamages.prototype, "info", void 0);
__decorate([
    claim.State('heliosDeclaration')
], DroughtDamages.prototype, "heliosDeclaration", void 0);
__decorate([
    claim.State('heliosError')
], DroughtDamages.prototype, "heliosError", void 0);
DroughtDamages = __decorate([
    Component({ components: { ModelInfo } })
], DroughtDamages);
export default DroughtDamages;
